import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type MapSwitchOverlayProps = {
  sheetName?: string;
  className?: string;
};

/** Overlay centré sur la zone carte pendant un changement d'onglet. */
export function MapSwitchOverlay({ sheetName, className = '' }: MapSwitchOverlayProps) {
  const { t } = useTranslation();
  const label = sheetName
    ? t('features.swimlane.sheetSwitchingNamed', { name: sheetName, defaultValue: `Loading ${sheetName}…` })
    : t('features.swimlane.sheetSwitching', { defaultValue: 'Loading sheet…' });

  return (
    <div
      className={`absolute inset-0 z-[30] flex items-center justify-center pointer-events-none ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="absolute inset-0 bg-white/55 backdrop-blur-[1px]" />
      <div className="relative flex flex-col items-center gap-3 rounded-xl border border-slate-200 bg-white/95 px-6 py-5 shadow-lg">
        <Loader2 className="h-9 w-9 animate-spin text-blue-600" strokeWidth={2.25} />
        <p className="m-0 text-sm font-medium text-slate-700 text-center max-w-[280px] truncate">
          {label}
        </p>
      </div>
    </div>
  );
}

export default MapSwitchOverlay;
